export const EmptyComponent = ({ message, description }: { message?: string; description?: string }) => {
  if (message && description) {
    return (
      <div className="cmp-filterable-list--emptynews ">
        <p className="cmp-filterable-list--emptynews-message">{message}</p>
        <p className="cmp-filterable-list--emptynews-description">{description}</p>
      </div>
    )
  }
  return (
    <div className="cmp-filterable-list--empty">
      <p>{message || 'The list is empty.'}</p>
    </div>
  )
}
